import { createContext } from 'react'
import { DeviceHttpProxyContextType } from '../types'

export const DeviceHttpProxyContext = createContext<DeviceHttpProxyContextType>(
  null
)
